<mat-expansion-panel class="subtask-expansion-panel">

  <!-- Header -->
  <mat-expansion-panel-header>
    <mat-panel-title class="subtask-panel-title">
      <span class="subtask-status-dot" [ngClass]="subtask.status"></span>
      <span class="subtask-panel-name">{{ subtask.name || 'Untitled Child Case' }}</span>
    </mat-panel-title>
    <mat-panel-description class="subtask-panel-desc">
      <span class="subtask-priority-badge" [ngClass]="'priority-' + subtask.priorityLevel">
        {{ priorityLabel }}
      </span>
      <span class="subtask-assignee-badge">{{ assigneeLabel }}</span>
      <button *ngIf="!canEditSubtask" mat-icon-button class="subtask-edit-btn"
        type="button" (click)="onEditRequested(); $event.stopPropagation()"
        matTooltip="Edit Child Case">
        <mat-icon>edit</mat-icon>
      </button>
    </mat-panel-description>
  </mat-expansion-panel-header>

  <!-- Body -->
  <div class="subtask-panel-body">

    <!-- Editable Form -->
    <app-subtask-form
      [subtask]="subtask"
      [index]="index"
      [canEdit]="canEditSubtask"
      (subtaskChange)="onSubtaskChange($event)"
      (removeSubtask)="onRemoveSubtask($event)">
    </app-subtask-form>

    <!-- Comments Section -->
    <div class="subtask-comments-section" *ngIf="subtask.comments.length || canAddComment">
      <div class="subtask-comments-title">Comments</div>

      <!-- Existing comments -->
      <div class="subtask-comment" *ngFor="let c of subtask.comments">
        <div class="subtask-comment-header">
          <span class="subtask-comment-author">{{ c.author }}</span>
          <span class="subtask-comment-date">{{ c.date | date:'MMM d, h:mma' }}</span>
        </div>
        <div class="subtask-comment-text">{{ c.text }}</div>
      </div>

      <!-- Add comment -->
      <div class="subtask-add-comment" *ngIf="canAddComment">
        <input type="text" class="subtask-comment-input" placeholder="Add a comment..."
          [(ngModel)]="newCommentText" (keyup.enter)="onAddComment()" />
        <button mat-icon-button class="subtask-comment-send" (click)="onAddComment()"
          [disabled]="!newCommentText.trim()">
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>

  </div>

</mat-expansion-panel>
